import { createApi } from "@reduxjs/toolkit/query/react";
import { stringify } from "qs";

import { baseQuery } from "../../../shared/api/base-query";
import { WeatherData } from "../containers/farm-land-weather-charts/types";

interface IMeteoDataByFarmLand {
  farmLandId: string;
  periodFrom: Date;
  periodTo: Date;
  interval: string;
}

interface IMeteoDataByLocation {
  interval: string;
  periodFrom: Date;
  periodTo: Date;
  longitude: number;
  latitude: number;
}

export const weatherApi = createApi({
  reducerPath: "weatherApi",
  baseQuery,
  tagTypes: ["WeatherApi"],
  endpoints: (build) => ({
    getMeteoDataByFarmLandId: build.query<WeatherData, IMeteoDataByFarmLand>({
      query: (meteoDataByFarmLandsParams: IMeteoDataByFarmLand) => {
        const meteoDataParams = stringify(meteoDataByFarmLandsParams);
        const relPath = "Meteodata/by-farm-land?" + meteoDataParams;

        return {
          url: relPath,
          method: "GET",
        };
      },
    }),
    getMeteoDataByLocation: build.query<WeatherData, IMeteoDataByLocation>({
      query: (meteoDataByLocationParams: IMeteoDataByLocation) => {
        const meteoDataParams = stringify(meteoDataByLocationParams);
        const relPath = "Meteodata/by-location?" + meteoDataParams;

        return {
          url: relPath,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetMeteoDataByFarmLandIdQuery, useGetMeteoDataByLocationQuery } =
  weatherApi;
